import { useContext } from 'react'
import styled from '@emotion/styled'
import { Flex } from 'rebass'
import { DataContext } from '../../contexts/dataContext'
import IntroGraphic from '../organisms/IntroGraphic'
import IntroInformation from '../organisms/IntroInformation'
import ConnectionGroup from '../molecules/ConnectionGroup'
import { MediaQueries as Mq } from '../../styles/settings/theme'

const IntroContainer = styled(Flex)`
  flex-direction: column;
  width: 100vw;
  height: calc(100% - 4.5rem);
  padding: 4rem 1.25rem 0rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 4.5rem;
  z-index: 30;
  display: ${(props) => (props.intro === 'closed' ? 'none' : 'flex')};
  overflow-y: auto;
  ${Mq.sm} {
    padding: 4rem 3rem;
    flex-direction: row;
    height: calc(100% - 3rem);
    top: 3rem;
  }
`

const Intro = () => {
  const { intro, ui } = useContext(DataContext)
  const dir = ui === 'en' ? 'ltr' : 'rtl'

  return (
    <IntroContainer intro={intro} dir={dir}>
      <ConnectionGroup flushLeft={ui === 'fa'} />
      {/* left column */}
      <IntroInformation />
      {/* right column */}
      <IntroGraphic />
    </IntroContainer>
  )
}

export default Intro
